/* istanbul ignore file */

import React from 'react';
import { visuallyHidden } from '@noths/polaris-client-styles';
import { priceFormatter } from '@noths/polaris-client-utils';

import { Price as PriceType } from 'src/types';
import * as styles from './styles';

type Props = PriceType & {
  testId?: string;
  className?: string;
  isSalePrice?: boolean;
  isPreviousPrice?: boolean;
};

export const Price = ({
  amount,
  currency,
  testId,
  isSalePrice = false,
  isPreviousPrice = false,
  className,
}: Props) => (
  <p
    data-testid={testId}
    data-is-sale-price={isSalePrice}
    data-is-previous-price={isPreviousPrice}
    css={styles.price}
    className={className}
  >
    {isSalePrice && <span css={visuallyHidden}>Sale price </span>}
    {isPreviousPrice && <span css={visuallyHidden}>Regular price </span>}
    {priceFormatter(currency, amount)}
  </p>
);
